import { HeaderSideImage, HeaderTextOverlay } from "./components";
import PropTypes from "prop-types";

export default function Header({ className, title, description, img, back, variant }) {
  switch (variant) {
    case "50/50":
      return <HeaderSideImage className={className} title={title} description={description} img={img} back={back} />;

    case "Under Text":
    default:
      return <HeaderTextOverlay className={className} title={title} description={description} img={img} back={back} />;
  }
}

Header.defaultProps = {
  variant: "Under Text",
};

Header.propTypes = {
  variant: PropTypes.oneOf(["50/50", "Under Text"]),
};
